"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const shadows = {
    1: '0px 1px 2px rgba(0, 0, 0, 0.1)',
    2: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    3: '0px 6px 12px rgba(0, 0, 0, 0.1)',
    4: '0px 8px 16px rgba(0, 0, 0, 0.1)',
    5: '0px 10px 24px rgba(0, 0, 0, 0.1)'
};
exports.default = shadows;
